/**
 * Fires a custom event
 * @param {String} eventName The name of the event
 * @param {Object} eventData Additional data pushed for listeners
 * @param {Element} source Element that will fire the event. Defaults to document.
 * @void
 */
 const fireEvent = function (eventName, eventData = {}, source = null) {
  const origin = source || document;
  origin.dispatchEvent(
    new CustomEvent(eventName, {
      detail: eventData
    })
  );
};


const customCloneDeep = (value) => {
  if (!isObject(value)) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(customCloneDeep);
  }

  const clone = {};

  for (const key in value) {
    if (value.hasOwnProperty(key)) {
      clone[key] = customCloneDeep(value[key]);
    }
  }

  return clone;
}
  
const isObject = (value) => {
  return typeof value === 'object' && value !== null;
}

export default  {
  fireEvent: fireEvent,
  customCloneDeep: customCloneDeep
}